import { render, staticRenderFns } from "./HowToLoraNew.vue?vue&type=template&id=4470d682&"
import script from "./HowToLoraNew.vue?vue&type=script&lang=js&"
export * from "./HowToLoraNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports